export interface AudioConfig {
  readonly enabled: boolean;
  /** Loudness per bus (0 … 1). */
  readonly volume: { readonly sfx: number; readonly footsteps: number; readonly music: number };
  /** Running footsteps: cadence follows the speed, clamped to what still sounds like running. */
  readonly footsteps: {
    /** Meters per step (one foot) at the start speed. */
    readonly strideLength: number;
    readonly minStepsPerSecond: number;
    readonly maxStepsPerSecond: number;
  };
  /** Moving hazards: cues further ahead than `range` are not heard, nearer ones fade in from `minLoudness`. */
  readonly hazards: { readonly range: number; readonly minLoudness: number };
  /**
   * Background music: the first of these files that exists is looped quietly
   * (public/assets/audio/music/ – drop the track there under one of these names).
   */
  readonly music: {
    readonly candidates: readonly string[];
    /** Seconds the music takes to fade in after the first tap/key. */
    readonly fadeInSeconds: number;
  };
}

export const AUDIO_CONFIG: AudioConfig = {
  enabled: true,
  // music quietly in the background (user: "nicht zu präsent"), effects on top
  volume: { sfx: 0.5, footsteps: 0.32, music: 0.15 },
  footsteps: { strideLength: 2.6, minStepsPerSecond: 2.8, maxStepsPerSecond: 5.2 },
  hazards: { range: 110, minLoudness: 0.35 },
  music: {
    // "Springy Adventure" (design/10_Music_noise) → MUS_RUN_LOOP.m4a; other formats as fallback names
    candidates: [
      '/assets/audio/music/MUS_RUN_LOOP.m4a',
      '/assets/audio/music/MUS_RUN_LOOP.mp3',
      '/assets/audio/music/MUS_RUN_LOOP.ogg',
    ],
    fadeInSeconds: 3,
  },
};
